/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

// Weglot.translate({
//   'words' : [ { "t":1,"w": "Ausverkauft" } ],
//   'languageTo' : 'en'
//   }, function(data) { 
//     $('.sold-out').each(function(){
//       $(this).text(data[0]);
//     });
//   }
// );
Weglot.on("languageChanged", function (newLang, prevLang) {
  // console.log("The language on the page just changed to (code): " + newLang)
  // console.log("The full name of the language is: " + Weglot.getLanguageName(newLang))
  setTimeout(function () {
    if (newLang == "en") {
      // PDP add to cart
      $('.btn.product__submit__add:not(:disabled) span').text('Add to shopping cart'); // sold out collection

      $('.sold-out').each(function () {
        var souldouttext = $(this).text();
        souldouttext = souldouttext.replace("Ausverkauft", "Sold out");
        $(this).text(souldouttext);
      }); // sold aus PDP

      $('.btn.product__submit__add:disabled span').each(function () {
        var item = $(this);
        var itemtext = item.text();
        itemtext = itemtext.replace("Ausverkauft", "Sold out");
        item.text(itemtext);
      });
      $('.cart-dropdown__items .cart-item, .priceminuss.display__inOneLine').each(function () {
        var item = $(this).find('small');
        var textSave = item.text();
        textSave = textSave.replace("Du sparst", "You save");
        item.text(textSave);
      });
    } else {
      // PDP add to cart
      $('.btn.product__submit__add:not(:disabled) span').text('In den Warenkorb'); // sold aus PDP

      $('.btn.product__submit__add:disabled span').each(function () {
        var item = $(this);
        var itemtext = item.text();
        itemtext = itemtext.replace("Sold out", "Ausverkauft");
        item.text(itemtext);
      }); // sold out collection

      $('.sold-out').each(function () {
        var souldouttext = $(this).text();
        souldouttext = souldouttext.replace("Sold out", "Ausverkauft");
        $(this).text(souldouttext);
      });
      $('.cart-dropdown__items .cart-item, .priceminuss.display__inOneLine').each(function () {
        var item = $(this).find('small');
        var textSave = item.text();
        textSave = textSave.replace("You save", "Du sparst");
        item.text(textSave);
      });
    }
  }, 200);
});
$('.button_swatcher').click(function () {
  // set Weglot translate Begin
  var newLang = Weglot.getCurrentLang();
  setTimeout(function () {
    if (newLang == "en") {
      $('.btn.product__submit__add:not(:disabled) span').text('Add to shopping cart');
    } else {
      // PDP add to cart
      $('.btn.product__submit__add:not(:disabled) span').text('In den Warenkorb');
    }
  }, 50); // Weglot translate End
  // chick if isdisabledif 

  if (!$(this).hasClass('button_disabled')) {
    $('.button_swatcher').removeClass("button_current");
    $(this).addClass("button_current");
    var varianteSize = $(this).attr('data-size');

    for (var i = 0; i < $('.radio__button').length; i++) {
      var variantTrimmed = $('.radio__button').eq(i).children('label').children('span').text().replace(/\s/g, "");

      if (variantTrimmed.includes(varianteSize)) {
        $('.radio__button').eq(i).children('label').children('span').trigger('click');
      }
    }
  }
});
$('.mesureOption').click(function () {
  $('.mesureOption').removeClass("selectedMesure");
  $(this).addClass("selectedMesure");

  if ($(this).attr('data-mesure') == 'eu') {
    $('.forEu').removeClass('no-display');
    $('.forUs').addClass('no-display');
    $('.forUk').addClass('no-display');
  } else if ($(this).attr('data-mesure') == 'us') {
    $('.forUs').removeClass('no-display');
    $('.forEu').addClass('no-display');
    $('.forUk').addClass('no-display');
  } else if ($(this).attr('data-mesure') == 'uk') {
    $('.forUk').removeClass('no-display');
    $('.forUs').addClass('no-display');
    $('.forEu').addClass('no-display');
  }
});

/***/ }),

/***/ "./src/scss/main.scss":
/*!****************************!*\
  !*** ./src/scss/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/main": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkvio_yoga"] = self["webpackChunkvio_yoga"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/scss/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;